export default __webpack_public_path__ + "static/media/h_blog2.30c00e89.jpg";